/*
|--------------------------------------------------------------------------
| Views: Search Results
|--------------------------------------------------------------------------
*/

/**
 * Pagination
 * @namespace
 */
__gh__webApp.views.searchResults = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){
		__gh__webApp.utilities.pagination.loadPagination();
	},


	"getSubView": function(bucket){
		var commonJS				= __gh__webApp.common,
			paginationDefaults		= __gh__webApp.utilities.pagination.defaults,
			viewName 				= "buckets/searchResults/default",
			itemsPerPage			= paginationDefaults.itemsPerPage,
			urlParams				= commonJS.getURLParamsAsObject(bucket.feedURL.toLowerCase()),
			viewName;

		// For pagination
		bucket.items.currentPage 	= (urlParams.hasOwnProperty("start")) ? urlParams.start : 1;
		bucket.items.totalPages 	= commonJS.divideAndRound(bucket.items.total,itemsPerPage);

		//Update bucket
		bucket.view.name 	= viewName;
		return bucket;

	}
};